import React from "react"

const NavButton = ({ children, onClick, active, open, depth = 2, isGroup=true }) => {

  const currentState = () => {
    let state = 0
    if(open && depth === 1) state = 1
    if(active && depth === 1) state = 2
    if(active && depth === 2) state = 3
    switch (state) {
      case 0 : return "text-slate-300 hover:bg-white/4 hover:text-white"
      case 1 : return "bg-nav-a font-semibold text-white"
      case 2 : return "bg-nav-b font-semibold text-white shadow-sm"
      case 3 : return "bg-white/10 font-semibold"
    }
  }

  return (
    <button
      onClick={onClick}
      className={`
        flex justify-between items-center w-full 
        rounded-lg cursor-pointer transition-all duration-150 text-left
        ${depth === 1 ? "px-3 py-2.5 text-[15px]" : "py-2 text-sm pl-3"}
        ${currentState()} ${isGroup ? "group" : ""}
      `}
    >
      {children}
    </button>
  )
}

export default NavButton